import { Api_routes, server_url } from '../config/API_Routes';
import { deleteRequest, getRequest, postRequest, putRequest } from '../config/axios-config';

const getInboundEmailTemplates = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.getInboundEmailTemplates,
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const createInboundEmailTemplate = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.createInboundEmailTemplate,
        body,
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateInboundEmailTemplate = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await putRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.updateInboundEmailTemplate,
        body,
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateInboundEmailTemplateOrder = (templateId, order) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await putRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.updateInboundEmailTemplateOrder +
          templateId,
        { order },
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const deleteInboundEmailTemplate = (templateId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.deleteInboundEmailTemplate +
          '/' +
          templateId,
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const getPrimaryEmailTemplateByType = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.getPrimaryEmailByType,
        body,
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const getUsageRightsTemplates = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.getUsageRightsTemplates,
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const createUsageRightsTemplate = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.createUsageRightsTemplate,
        body,
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateUsageRightsTemplate = (body, templateId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await putRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.updateUsageRightsTemplate +
          '/' +
          templateId,
        body,
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateSystemUsageRightsTemplate = (body) => {
  console.log('updating system template service');
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.updateSystemUsageRightsTemplate,
        body,
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const deleteUsageRightsTemplate = (templateId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await deleteRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.deleteUsageRightsTemplate +
          '/' +
          templateId,
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export {
  getInboundEmailTemplates,
  createInboundEmailTemplate,
  updateInboundEmailTemplate,
  updateInboundEmailTemplateOrder,
  deleteInboundEmailTemplate,
  getPrimaryEmailTemplateByType,
  getUsageRightsTemplates,
  createUsageRightsTemplate,
  updateUsageRightsTemplate,
  updateSystemUsageRightsTemplate,
  deleteUsageRightsTemplate,
};
